import React, { useState, useEffect } from 'react';
import {Table, Button, Input, InputNumber, Select, Tag, Typography, Card} from 'antd';
import { t } from 'i18next';
import { useUser } from '../../core/context/UserContext';
import Helper from "../../core/Helper";

export default function AppointmentOperationSubItemsEdit({ subItems, selectedSubItems, onSave, currency = 'TRY' }) {
    const [selectedItems, setSelectedItems] = useState([]);
    const [searchText, setSearchText] = useState('');
    const { user } = useUser();

    useEffect(() => {
        setSelectedItems(selectedSubItems);
    }, [subItems, selectedSubItems]);

    const handleAdd = (item) => {
        setSelectedItems([...selectedItems, { ...item, id: item.id }]);
    };

    const handleDelete = (key) => {
        setSelectedItems(selectedItems.filter(i => i.id !== key));
    };

    const handleEdit = (key, field, value) => {
        setSelectedItems(selectedItems.map(item => item.id === key ? { ...item, [field]: value } : item));
    };

    const filteredItems = subItems
        .filter(item => !selectedItems.some(selected => selected.id === item.id))
        .filter(item =>
            Helper.Text.normalizeText(item.name).includes(Helper.Text.normalizeText(searchText))
        );

    const availableColumns = [
        {
            title: '#',
            width: 60,
            key: 'actions',
            render: (_, record) => (
                <Button size={'small'} onClick={() => handleAdd(record)}>{t('+')}</Button>
            ),
        },
        {
            title: t('Name'),
            dataIndex: 'name',
            key: 'name',
        },
    ];

    const selectedColumns = [
        {
            title: t('Name'),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: t('Price') + ' (' + currency + ')',
            dataIndex: 'price',
            key: 'price',
            render: (text, record) => (
                <InputNumber
                    size={'small'}
                    value={text}
                    onChange={(value) => handleEdit(record.id, 'price', value)}
                />
            ),
        },
        {
            title: '#',
            key: 'actions',
            render: (_, record) => (
                <Button size={'small'} danger onClick={() => handleDelete(record.id)}>{t('Delete')}</Button>
            ),
        },
    ];

    return (
        <div>
            <Typography.Title level={5}>
                {t('Selected Sub Operations')}
            </Typography.Title>
            <Table
                size={'small'}
                rowKey={'id'}
                columns={selectedColumns}
                dataSource={selectedItems}
                pagination={false}
                scroll={{ y: 240 }}
                style={{ minHeight: 240 }}
                summary={() => {
                    const total = selectedItems.reduce((sum, item) => sum + (item.price || 0), 0);
                    return (
                        <>
                            <Table.Summary.Row>
                                <Table.Summary.Cell index={1}>
                                    <Typography.Text strong>{t('Total')}</Typography.Text>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={2} colSpan={3}>
                                    <Typography.Text strong>{Helper.Currency.format(total, {currency})}</Typography.Text>
                                </Table.Summary.Cell>
                            </Table.Summary.Row>
                            <Table.Summary.Row>
                                <Table.Summary.Cell index={1} colSpan={4}>
                                    <Button
                                        type={'primary'}
                                        size={'small'}
                                        style={{marginTop: 16}}
                                        onClick={() => onSave(selectedItems)}
                                    >
                                        {t('Save')}
                                    </Button>
                                </Table.Summary.Cell>
                            </Table.Summary.Row>
                        </>
                    );
                }}
            />

            <Card style={{backgroundColor: '#fafafa'}}>
                <Typography.Title level={5}>
                    {t('Sub Operations')}
                </Typography.Title>
                <Input
                    placeholder={t('Search by name or tag')}
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    style={{ marginBottom: 16 }}
                />
                <Table
                    size={'small'}
                    rowKey={'id'}
                    columns={availableColumns}
                    dataSource={filteredItems}
                    pagination={{ size: "small", pageSize: 10 }}
                />
            </Card>
        </div>
    );
}